export const brandColors = {
  ink: '#1a0c3e',
  deepInk: '#2f224e',
  magenta: '#ff258e',
  pink: '#e428af',
  purple: '#7443f1',
  violet: '#9e4ef0',
  blue: '#168fff',
  sky: '#35c7ff',
  orange: '#f78a63',
  warm: '#ffb44a',
} as const;

export const colors = {
  background: '#f9f8fb',
  surface: '#ffffff',
  surfaceTint: '#fff7fc',
  surfacePressed: '#f2eef8',
  text: brandColors.ink,
  mutedText: '#6c5ba7',
  border: '#ebeaea',
  primary: brandColors.magenta,
  primaryPressed: '#d91f78',
  secondary: brandColors.purple,
  secondaryPressed: '#5e35cf',
  accent: brandColors.blue,
  accentSoft: '#edf7ff',
  warmAccent: brandColors.orange,
  danger: '#d7375f',
  dangerPressed: '#b92d4f',
  success: '#168f62',
  inputBackground: '#ffffff',
} as const;
